<template>
  <div>
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="">
        <b class="pr-1">Sparing</b> <span class="dot normal" /> Normal <span class="dot abnormal" />
        Abnormal
        <b class="sidebar-right">
          {{ datenow }}
        </b>
      </b-card>
      <b-col
        cols="10"
        md="12"
      >
        <b-row rows="5">
          <b-col
            cols="3"
            md="3"
          >
            <b-card title="PH">
              <vue-apex-charts
                type="radialBar"
                height="200"
                :options="goalOverviewRadialBarTemperature"
                :series="[valueToPercent(realtime_ph)]"
              />
            </b-card>
          </b-col>
          <b-col
            cols="3"
            md="9"
          >
            <b-card>
              <span style="font-size: 1.50rem;">PH</span>
              <vue-apex-charts
                class="vue-apex-charts"
                type="area"
                height="165"
                :options="lineChartSimpleTemperaturePh.chartOptions"
                :series="lineChartSimpleTemperaturePh.series"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        cols="10"
        md="12"
      >
        <b-row>
          <b-col
            cols="3"
            md="3"
          >
            <b-card>
              <span style="font-size: 1.50rem;">COD</span>
              <div
                style="font-size: 2.50rem; color: green; display: flex; align-items: center; justify-content: center;"
                :style="{ color: this.realtime_cod < 0 || this.realtime_cod > 100 ? '#FC4C02' : 'green' }"
              >
                <span style="font-weight: bold;">{{ this.realtime_cod }}</span><small
                  style="font-weight: bold; margin-left: 5px;"
                > ppm</small>
              </div>
              <vue-apex-charts
                class="vue-apex-charts"
                type="area"
                height="250"
                :options="lineChartSimpleTemperatureCod.chartOptions"
                :series="lineChartSimpleTemperatureCod.series"
              />
            </b-card>
          </b-col>
          <b-col
            cols="3"
            md="3"
          >
            <b-card>
              <span style="font-size: 1.50rem;">TSS</span>
              <div
                style="font-size: 2.50rem; color: green; display: flex; align-items: center; justify-content: center;"
                :style="{ color: this.realtime_nh3n < 0 || this.realtime_nh3n > 150 ? '#FC4C02' : 'green' }"
              >
                <span style="font-weight: bold;">{{ this.realtime_nh3n }}</span><small
                  style="font-weight: bold; margin-left: 5px;"
                > ppm</small>
              </div>
              <vue-apex-charts
                type="area"
                height="250"
                :options="lineChartSimpleTemperatureTss.chartOptions"
                :series="lineChartSimpleTemperatureTss.series"
              />
            </b-card>
          </b-col>
          <b-col
            cols="3"
            md="3"
          >
            <b-card>
              <span style="font-size: 1.50rem;">Debit</span>
              <div
                style="font-size: 2.50rem; color: green; display: flex; align-items: center; justify-content: center;"
              >
                <span style="font-weight: bold;">{{ this.realtime_debit }}</span><small
                  style="font-weight: bold; margin-left: 5px;"
                > m3/h</small>
              </div>
              <vue-apex-charts
                type="area"
                height="250"
                :options="lineChartSimpleTemperatureDebit.chartOptions"
                :series="lineChartSimpleTemperatureDebit.series"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>

      <b-row
        xl="12"
        sm="12"
        style="display: none;"
      >
        <b-col
          cols="3"
          md="4"
          class="mb-md-0 mb-2"
        >
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              cols="12"
              md="12"
              class="mb-md-0 mb-2"
            >
              <b-card title="">
                <div
                  class="my-auto"
                  style="text-align: center;"
                >
                  <b-row
                    xl="12"
                    sm="12"
                  >
                    <b-col
                      cols="12"
                      md="12"
                      style="text-align: center;"
                    >
                      <b-img :src="icon1" />
                    </b-col>
                  </b-row>
                </div>
                <div
                  class="my-auto"
                  style="text-align: center;"
                >
                  <h1 class="font-weight-bolder mb-0">
                    32 &#x2103;
                  </h1>
                </div>
                <div
                  class="my-auto"
                  style="text-align: center;"
                >
                  <b-row
                    xl="12"
                    sm="12"
                  >
                    <b-col
                      cols="6"
                      md="6"
                    >
                      <p class="font-weight-bolder mb-0">
                        Overcast
                      </p>
                    </b-col>
                    <b-col
                      cols="6"
                      md="6"
                    >
                      <p class="font-weight-bolder mb-0">
                        Rainfall
                      </p>
                    </b-col>
                  </b-row>
                </div>
                <hr>
                <b-row
                  xl="12"
                  sm="12"
                >
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="CalendarIcon" /> {{ datenow }}
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Wind Velocity
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Wind Direction
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Barometric Pressure
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> PM 2.5
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> PM 10
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Sound Level
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> CO2
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Company
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Location
                    </p>
                  </b-col>
                  <b-col
                    cols="12"
                    md="12"
                  >
                    <p class="font-weight-bolder mb-1">
                      <feather-icon icon="MapPinIcon" /> Area
                    </p>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          cols="8"
          md="8"
          class="mb-md-0 mb-2"
        >
          <b-row
            xl="12"
            sm="12"
          />
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCard, BOverlay, BTable, BImg, BInputGroup, BInputGroupAppend, BCardBody, BLink, BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BRow, BCol, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import { computed, watch } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { mapState } from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import { $themeColors } from '@themeConfig'

const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")
const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
// colors
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}
export default {
  components: {
    flatPickr, moment, VueApexCharts, BCard, BOverlay, BTable, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BRow, BCol, BDropdown, BDropdownItem, ToastificationContent,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')
    watch(isDark, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        // Memuat ulang halaman saat nilai isDark berubah
        window.location.reload()
      }
    })
    return { skin, isDark }
  },
  data() {
    return {
      goalOverviewRadialBarTemperature: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '57%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
                formatter(val) {
                  return parseFloat(((val * (10 - 2)) / 100 + 2).toFixed(2))
                },
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      lineChartSimpleTemperaturePh: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              areas: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 6,
            max: 9,
          },
        },
      },
      lineChartSimpleTemperatureCod: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 150,
          },
        },
      },
      lineChartSimpleTemperatureNh3n: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      lineChartSimpleTemperatureTss: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
            value: {
              formatter(val) {
                return val
              },
            },
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 150,
          },
        },
      },
      lineChartSimpleTemperatureDebit: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 500,
          },
        },
      },
      lineChartAlarm: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      lineChartUps: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      lineChartPln: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: ['#28C76F', '#247BA0', '#EA5455'],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${data.series[data.seriesIndex][data.dataPointIndex]
              }</span></div>`
            },
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: '',
              },
            },
            min: 0,
            max: 1,
          },
        },
      },
      realtime_ph: 0,
      realtime_cod: 0,
      realtime_nh3n: 0,
      realtime_tss: 0,
      realtime_debit: 0,
      realtime_alarm: null,
      realtime_ups: null,
      realtime_pln: null,
      history_ph: [],
      history_cod: [],
      history_nh3n: [],
      history_tss: [],
      history_debit: [],
      realtime_time: [],
      icon1: require('@/assets/images/icons/GroupCloud.png'),
      icon2: require('@/assets/images/icons/WaterReservoir.png'),
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
      province_id: '',
      regency_id: '',
      district_id: '',
      site_id: '',
      show: false,
    }
  },
  computed: {
    ...mapState({
      sparing: state => state.temperature.dashboard.sparing,
    }),
    // isAdditionalParams() {
    //   return this.realtime_alarm !== null || this.realtime_ups !== null || this.realtime_pln !== null
    // },
  },
  created() {
    this.show = true
    if (this.isDark === true) {
      this.goalOverviewRadialBarTemperature.plotOptions.radialBar.dataLabels.value.color = '#ffffff'
      this.lineChartSimpleTemperatureDebit.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureCod.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureNh3n.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureTss.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperaturePh.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartAlarm.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartUps.chartOptions.xaxis.labels.style.colors = '#ffffff'
      this.lineChartPln.chartOptions.xaxis.labels.style.colors = '#ffffff'

      this.lineChartSimpleTemperatureCod.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureNh3n.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperaturePh.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureTss.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartSimpleTemperatureDebit.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartAlarm.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartUps.chartOptions.yaxis.labels.style.colors = '#ffffff'
      this.lineChartPln.chartOptions.yaxis.labels.style.colors = '#ffffff'
    }
    setInterval(() => this.updateCurrentTime(), 1000)
    setInterval(() => this.getData(), 30000)
    // this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', true)
    this.getData()
  },
  destroyed() {
    // this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', this.menuHidden)
  },
  methods: {
    valueToPercent(val) {
      return ((val - 2) * 100 / (10 - 2)).toFixed(2)
    },
    updateCurrentTime() {
      this.datenow = getCurrentTime()
    },
    getData() {
      this.$store.dispatch('temperature/getDashboardSparingNew').then(resp => {
        this.injectData(resp)
      })
    },
    injectData(resp) {
      // this.goalOverviewRadialBarTemperature.plotOptions.radialBar.dataLabels.value.formatter = this.realtime_ph.device_value
      this.history_ph = []
      this.history_cod = []
      this.history_nh3n = []
      this.history_tss = []
      this.history_debit = []
      this.history_alarm = []
      this.history_ups = []
      this.history_pln = []
      this.realtime_time = []

      this.realtime_ph = resp.device_realtime.ph
      this.realtime_cod = resp.device_realtime.cod
      this.realtime_nh3n = (resp.device_realtime.tss).toFixed(2)
      this.realtime_tss = resp.device_realtime.nh3n
      this.realtime_debit = resp.device_realtime.debit
      this.realtime_alarm = 'alarm' in resp.device_realtime ? resp.device_realtime.alarm : null
      this.realtime_ups = 'ups' in resp.device_realtime ? resp.device_realtime.ups : null
      this.realtime_pln = 'pln' in resp.device_realtime ? resp.device_realtime.pln : null
      this.lineChartSimpleTemperaturePh.series[0] = {
        name: 'PH Avg : ',
        data: this.history_ph,
      }
      this.lineChartSimpleTemperatureCod.series[0] = {
        name: 'COD Avg : ',
        data: this.history_cod,
      }
      this.lineChartSimpleTemperatureNh3n.series[0] = {
        name: 'NH3N Avg : ',
        data: this.history_nh3n,
      }
      this.lineChartSimpleTemperatureTss.series[0] = {
        name: 'TSS Avg : ',
        data: this.history_tss,
      }
      this.lineChartSimpleTemperatureDebit.series[0] = {
        name: 'Debit Avg : ',
        data: this.history_debit,
      }
      this.lineChartAlarm.series[0] = {
        name: 'Alarm Avg : ',
        data: this.history_alarm,
      }
      this.lineChartUps.series[0] = {
        name: 'UPS Avg : ',
        data: this.history_ups,
      }
      this.lineChartPln.series[0] = {
        name: 'PLN Avg : ',
        data: this.history_pln,
      }

      this.lineChartSimpleTemperaturePh.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureCod.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureNh3n.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureTss.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartSimpleTemperatureDebit.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartAlarm.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartUps.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }
      this.lineChartPln.chartOptions = {
        xaxis: { categories: this.realtime_time },
      }

      this.lineChartSimpleTemperaturePh.chartOptions.annotations = {
        yaxis: [{
          y: 9,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 6,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureCod.chartOptions.annotations = {
        yaxis: [{
          y: 75,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureNh3n.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureTss.chartOptions.annotations = {
        yaxis: [{
          y: 50,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartSimpleTemperatureDebit.chartOptions.annotations = {
        yaxis: [{
          y: 500,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartAlarm.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }
      this.lineChartUps.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      this.lineChartPln.chartOptions.annotations = {
        yaxis: [{
          y: 1,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MAX VALUE',
          },
        },
        {
          y: 0,
          borderColor: '#F89599',
          label: {
            borderColor: '#F89599',
            style: {
              color: '#fff',
              background: '#F89599',
            },
            text: 'MIN VALUE',
          },
        }],
      }

      const startIndex = 0
      const endIndex = Math.min(10, resp.device_history.length)
      resp.device_history.slice(startIndex, endIndex).map(x => {
        this.history_ph.push(x.ph)
        this.history_cod.push(x.cod)
        this.history_nh3n.push(x.nh3n)
        this.history_alarm.push(x.alarm)
        this.history_ups.push(x.ups)
        this.history_pln.push(x.pln)

        x.tss = parseFloat(resp.device_realtime.tss).toFixed(2)
        this.history_tss.push(x.tss)

        x.debit = parseFloat(resp.device_realtime.debit * 60).toFixed(1)
        this.history_debit.push(x.debit)

        x.recorded_at = this.$options.filters.formatDateTime(x.recorded_at)
        this.realtime_time.push(x.recorded_at)
      })
      this.show = false
    },
  },
}
</script>
<style lang="scss">
.my-custom-class .card-title {
    color: white;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.normal {
  background-color: #03ff4a;
}

.abnormal {
  background-color: #FC4C02;
}
</style>
